"use client";

import { WithLayout, withLayout } from "@/lib/puck/components/Layout";
import { ComponentConfig, FieldLabel } from "@measured/puck";
import { Editor as TinyMCE } from "@tinymce/tinymce-react";
import { Section } from "@/lib/puck/components/Section";

export type EditorProps = WithLayout<{
  text?: string;
}>;

const EditorInner: ComponentConfig<EditorProps> = {
  fields: {
    text: {
      type: "custom",
      render: ({ value, onChange }) => {
        return (
          <FieldLabel label="Editor">
            <TinyMCE
              licenseKey="gpl"
              tinymceScriptSrc="https://cdnjs.cloudflare.com/ajax/libs/tinymce/8.1.2/tinymce.min.js"
              init={{
                height: 200,
                menubar: false,
                statusbar: false,
                branding: false,
                plugins: "link lists table",
                toolbar: "bold italic | bullist numlist | link | table",
              }}
              initialValue={value}
              onBlur={(_, editor) => {
                onChange(editor.getContent());
              }}
            />
          </FieldLabel>
        );
      },
    },
  },
  defaultProps: {
    text: "",
  },
  render: ({ text }) => {
    return (
      <Section>
        <div
          className="prose max-w-full"
          dangerouslySetInnerHTML={{ __html: text || "" }}
        />
      </Section>
    );
  },
};

export const Editor = withLayout(EditorInner);
